import { NgModule } from '@angular/core';
import { CollectionItemDirective } from './collection-item.directive';
import { CollectionContainerDirective } from './collection-container.directive';

@NgModule({
  declarations: [CollectionItemDirective, CollectionContainerDirective],
  exports: [CollectionItemDirective, CollectionContainerDirective]
})
export class CollectionModule { }
